import React from "react";

function isTextInput(el: Element | null): boolean {
  return el ? ["INPUT", "TEXTAREA"].includes(el.tagName) : false;
}

export function preventDragOnTextInput(e: React.DragEvent): void {
  if (
    isTextInput(e.target as HTMLElement) ||
    isTextInput(document.activeElement)
  ) {
    e.preventDefault();
  }
}
